import { graphql } from '@eluve/graphql-fhir';

/**
 * FHIR Patient lookup by Eluve patient identifier (the Hasura patient id the
 * profile route carries) — same seam as the Observations card.
 */
export const FHIR_PATIENT_ID_QUERY = graphql(`
  query FhirTasksPatientId($identifier: String!) {
    PatientList(identifier: $identifier, _count: 1) {
      id
    }
  }
`);

/**
 * The signed-in clinician's tasks for this patient (ENG-5368): owner-scoped
 * server-side, Clinical Tasks status semantics — the decided lifecycle set
 * (`requested`/`in-progress`/`completed`, same as the appointment panel);
 * `draft` proposals and `cancelled` tombstones never match. No renderer
 * fragment exists for Task; this selection is the card's own display
 * contract.
 */
export const PATIENT_TASKS_QUERY = graphql(`
  query FhirPatientTasks(
    $patientRef: String!
    $ownerRef: String!
    $offset: Int
  ) {
    TaskConnection(
      patient: $patientRef
      owner: $ownerRef
      status: "requested,in-progress,completed"
      _count: 100
      _offset: $offset
      _sort: "-authored-on"
    ) {
      count
      offset
      edges {
        resource {
          resourceType
          id
          meta {
            versionId
          }
          status
          intent
          priority
          description
          authoredOn
          code {
            coding {
              system
              code
            }
            text
          }
          restriction {
            period {
              end
            }
          }
          owner {
            reference
            display
            resource {
              ... on Practitioner {
                resourceType
                id
                name {
                  prefix
                  given
                  family
                }
              }
            }
          }
        }
      }
    }
  }
`);
